export default {
    control: {
      backgroundColor: '#fff',
      fontSize: 14,
      fontWeight: 'normal',
    },
  
    '&multiLine': {
      control: {
        fontFamily: 'monospace',
        minHeight: 63,
        lineHeight: 1.5,
      },
      highlighter: {
        padding: 9,
        border: '1px solid transparent',
        lineHeight: 1.5,
        font: 'inherit',
      },
      input: {
        padding: 9,
        border: '1px solid silver',
        lineHeight: 1.5,
        // UA stylesheets often set a different font on textarea; must match highlighter exactly.
        font: 'inherit',
        // Let the highlighter paint plain + mention colors; only the caret stays visible.
        color: 'transparent',
        caretColor: '#333',
      },
    },
  
    '&singleLine': {
      display: 'inline-block',
      width: 180,
  
      highlighter: {
        padding: 1,
        border: '2px inset transparent',
      },
      input: {
        padding: 1,
        border: '2px inset',
        color: 'transparent',
        caretColor: '#333',
      },
    },
  
    suggestions: {
      list: {
        backgroundColor: 'white',
        border: '1px solid rgba(0,0,0,0.15)',
        fontSize: 14,
        height: 200,
        overflowY: 'auto',
        boxSizing: 'border-box',
      },
      item: {
        padding: '5px 15px',
        borderBottom: '1px solid rgba(0,0,0,0.15)',
        '&focused': {
          backgroundColor: '#cee4e5',
        },
      },
    },
}
  